module.exports = __webpack_public_path__ + "static/front-desk-mobile-eee91fdd9541e8922a50e54b44600c53.jpg";